﻿import { apiClient } from '@api/apiClient';

export async function logout() {
  const response = await apiClient.post('/logout');

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  // @ts-expect-error this is a workaround for the API returning a string instead of a boolean
  return response as boolean;
}
